import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Compass } from "lucide-react";
import { CATEGORIES, SITE } from "@/lib/site";
import { SearchDialog } from "@/components/SearchDialog";

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 bg-brand-bg/85 backdrop-blur-xl border-b border-brand-line">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" data-testid="logo-home-link" className="flex items-center gap-2 group">
            <span className="w-9 h-9 rounded-full bg-brand-terra text-white flex items-center justify-center">
              <Compass size={20} />
            </span>
            <span className="font-heading text-2xl font-semibold tracking-tight text-brand-ink group-hover:text-brand-terra transition-colors">
              {SITE.name}
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-7">
            {CATEGORIES.map((c) => (
              <NavLink
                key={c.slug}
                to={`/categoria/${c.slug}`}
                data-testid={`nav-${c.slug}`}
                className={({ isActive }) =>
                  `text-sm font-medium transition-colors hover:text-brand-terra ${
                    isActive ? "text-brand-terra" : "text-brand-ink"
                  }`
                }
              >
                {c.short}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <SearchDialog />
            <Link
              to="/contacto"
              data-testid="nav-newsletter-cta"
              className="hidden sm:inline-flex bg-brand-terra hover:bg-brand-terraDark text-white text-sm font-semibold px-4 py-2 rounded-sm transition-all hover:-translate-y-0.5"
            >
              Contacto
            </Link>
            <button
              data-testid="mobile-menu-button"
              className="lg:hidden p-2"
              onClick={() => setOpen(!open)}
              aria-label="Menú"
            >
              {open ? <X size={22} /> : <Menu size={22} />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <nav className="lg:hidden border-t border-brand-line bg-brand-bg px-4 py-3 flex flex-col gap-1">
          {CATEGORIES.map((c) => (
            <NavLink
              key={c.slug}
              to={`/categoria/${c.slug}`}
              onClick={() => setOpen(false)}
              data-testid={`mobile-nav-${c.slug}`}
              className="py-2 text-brand-ink font-medium border-b border-brand-line/50"
            >
              {c.name}
            </NavLink>
          ))}
          <Link to="/contacto" onClick={() => setOpen(false)} className="py-2 text-brand-terra font-semibold">
            Contacto
          </Link>
        </nav>
      )}
    </header>
  );
};
